import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { H1 } from 'components/common/Text/Text'
import Theme from 'components/common/Theme/Theme'
import { ActionButton } from './components/SharedStyles'
import { NEXT_APPOINTMENT_MY_GARAGE_CLASS, SUCCESS_UPDATE_MESSAGE } from './constants'
import Notification from 'components/common/Notification'

const MyGaragePage = ({
  children,
  addNewVehicle,
  noOfVehicles,
  gridTemplateAreas
}) =>
  <Wrapper>
    <Header>
      <MainTitle data-at-garage-title headline noMargin>My garage</MainTitle>
      <AddButton
        data-at-add-a-vehicle-button
        narrow
        primary
        onClick={ addNewVehicle }>+ Add a vehicle</AddButton>
    </Header>
    <MyGarageWrapper>
      <GarageDashboardGrid noOfVehicles={ noOfVehicles } gridTemplateAreas={ gridTemplateAreas }>
        {children}
      </GarageDashboardGrid>
      <UpdateVehicleNotification
        title={ SUCCESS_UPDATE_MESSAGE }
        asset="check-circle"
        className="personalization-success"
        success />
    </MyGarageWrapper>
  </Wrapper>

MyGaragePage.propTypes = {
  addNewVehicle: PropTypes.func,
  children: PropTypes.node,
  gridTemplateAreas: PropTypes.shape(),
  noOfVehicles: PropTypes.number
}

export default MyGaragePage

const Header = styled.div`
  position: relative;
  ${Mixin.responsive('margin-bottom', '30px', '26px')}
`

const MainTitle = styled(H1)`
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 600)}
  `}
`

const AddButton = styled(ActionButton)`
  position: absolute;
  right: 0;
  ${Mixin.responsive('top', '0', '-5px')}
`

const Wrapper = styled.div`
  ${Mixin.responsive('padding', '0', '0 16px')}
`

const MyGarageWrapper = styled.div`
  position: relative;
  max-width: 100vw;
  width: calc(100vw - 16px);
  margin-left: calc(50% - 50vw - -8px);
  display: flex;
  justify-content: center;
  background: ${Theme.colors.white_smoke};
  ${Media.tablet`
    width: calc(100vw);
    margin-left: calc(50% - 50vw);
  `}

  ${Media.mobile`
    width: calc(100vw);
    margin-left: calc(50% - 50vw);
  `}
`

const GarageDashboardGrid = styled.div`
  width: 100%;
  max-width: 1570px;
  ${Mixin.responsive('padding', '29px 50px 25px', '16px 16px 25px')}
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(3, minmax(200px, 1fr));
  ${(props) => !props.noOfVehicles && css`
    grid-template-areas: ${props.gridTemplateAreas.garageGridNoVehicles.desktop};

    @media (max-width: 1384px) {
      grid-template-areas: ${props.gridTemplateAreas.garageGridNoVehicles.laptop};
      grid-template-columns: repeat(2, minmax(200px, 1fr));
      grid-row-gap: 20px;
    }
    @media (max-width: 1023px) {
      grid-template-areas: ${props.gridTemplateAreas.garageGridNoVehicles.mobile};
      grid-template-columns: minmax(200px, 1fr);
    }
  `}
  ${(props) => props.noOfVehicles && css`
      grid-template-areas: ${props.gridTemplateAreas.garageGridWithVehicles.desktop};
      grid-row-gap: 20px;
      grid-template-rows: 250px 250px 1fr;

      @media (max-width: 1384px) {
        grid-template-columns: 24% 24% 49%;
        grid-template-areas: ${props.gridTemplateAreas.garageGridWithVehicles.laptop};
      }

      @media (max-width: 1023px) {
        grid-template-areas: ${props.gridTemplateAreas.garageGridWithVehicles.mobile};
        grid-template-columns: minmax(200px, 1fr);
        grid-template-rows: auto;
      }
  `}

  .${NEXT_APPOINTMENT_MY_GARAGE_CLASS} {
    align-self: start;
  }
`

const UpdateVehicleNotification = styled(Notification)`
  position: absolute;
  top: -34px;
  ${Media.mobile`
    z-index: 500;
    width: 300px;
    font-size: 12px;
    padding: 12px 13px;
    top: -143px;
  `}
`
